<template>
  <transition name="modal" v-if="imageModalData && imageModalData.magnifyImg">
    <div class="modalcon">
      <div class="modal-mask" @click="$emit('close')">
        <div class="modal-wrapper">
          <div class="modal-container d-flex justify-content-center">
            <div class="main-img prelative">
              <div class="closebtn" @click="$emit('close')">X</div>
              <img :data-src="imageModalData.magnifyImg" :alt="imageModalData.alt || 'Size Chart'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

  export default {
    data () {
      return {
      }
    },
    props: ['imageModalData'],
    methods: {},
    mounted () {
      // hide vertical scroll on body on mount
      const el = document.querySelector('body')
      el && el.classList.add('overflow-y-hidden')
    },
    destroyed () {
      // remove hidden vertical scroll on destroy
      const el = document.querySelector('body')
      el && el.classList.remove('overflow-y-hidden')
    }
  }
</script>
<style scoped="scoped">
  .zoomimage {
    position: relative;
    width: 410px;
    left: 50%;
    margin-left: -205px;
    text-align: right;
    color: #fff;
    margin-top: 30px;
  }

  .zoomimage .main-img {
    width: 100%;
    position: absolute;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 10000;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;

  }
  .second-no-wrapper {
    position: relative;
  }

  .closebtn {
    position: absolute;
    right: 12px;
    top: 5px;
    color: white;
    cursor: pointer;
    z-index: 1;
  }

  .print-content {
    position: absolute;
    top: 0;
    top: 30%;
    color: black;
  }
  .print-content p{
    margin-bottom: 0px;
  }
  .print-name {
    font-size: 1.4rem;
    font-weight: bold;
  }

  .print-number {
    font-size: 5rem;
    font-weight: bold;
    text-transform: capitalize;
    line-height: 1;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    margin: 0px auto;
    transition: all 0.3s ease;
    width: 410px;
  }
  .modal-container .main-img {
    width: fit-content;
  }

  .modal-header {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-footer {
    padding: 15px 5px 5px 5px;
  }

  .modal-body {
    margin: 0px 0 0px 0;
    padding: 0px;
    position: relative;
    height: 100%;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .imageOverNumber {
    position: absolute;
    top: 10px;
    right: -15px;
    width: 35px;
  }

  @media screen and (max-width: 768px) {
    .zoomimage {
      width: 320px;
      margin-left: -160px;
    }

    .printName {
      top: 80px;
      font-size: 16px;
    }

    .printNumber {
      top: 85px;
      font-size: 75px;
    }

    .number1 {
      margin: 0px 0px 0px -35px;
    }

    .number2 {
      margin: 0px 0px 0px 38px;
    }

    .imageOverNumber {
      bottom: 37px;
      right: -10px;
      width: 30px;
    }
  }
  @media screen and (max-width: 420px){
    .modal-container{
      width: 92%;
    }
  }
  @media screen and (max-width: 360px){
    .modal-container {
      width: 90%;
    }
  }
   @media screen and (max-width: 320px){
    .modal-container {
      width: 88%;
    }
  }
</style>



// WEBPACK FOOTER //
// sizeimageModal.vue?8f2c0868